<template>
  <div class="p-4 sm:p-6 border border-gray-200 rounded-lg shadow-sm bg-white min-h-[200px] md:min-h-[calc(100vh-200px)] max-h-[calc(100vh-150px)] overflow-y-auto">
    <div v-if="file" class="markdown-content">
      <h2 class="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 pb-2 border-b border-gray-300 text-gray-800">{{ file.name }}</h2>
      <div v-html="renderedMarkdown"></div>
    </div>
    <div v-else class="text-gray-500 flex items-center justify-center h-full text-center">
      <p class="text-lg">Select a note from the list to view its content,<br>or upload a new one.</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { marked } from 'marked'

const props = defineProps({
  file: {
    type: Object,
    default: null
  }
})

const renderedMarkdown = computed(() => {
  if (props.file && props.file.content) {
    try {
      return marked.parse(props.file.content, {
        gfm: true,
        breaks: true
      })
    } catch (error) {
      console.error('Error parsing Markdown:', error)
      return "<p class='text-red-500'>Error rendering Markdown. Please check the file content.</p>"
    }
  }
  return ''
})
</script>

<style scoped>
/* Component-specific markdown styles */
.markdown-content {
  line-height: 1.6;
}
</style>
